import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const TeamEdgeProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Team Effectiveness Assessment Nigeria | TeamEdge™ Lagos"
        description="TeamEdge™ team effectiveness assessment for Nigerian organisations. See where a team is strong and where it is stuck, across six dimensions. Built for African teams."
        keywords="team effectiveness Nigeria, team assessment Lagos, team performance Nigeria, team diagnostic Africa, TeamEdge"
        canonical="https://impactasportal.com/product/team-edge"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/team-edge?embed=true"
            title="TeamEdge™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default TeamEdgeProductPage;
